import PageHeader from '@/components/PageHeader'
import tableMixin from '@/minxin/table-minxin'
import Adsearch from '@/components/Adsearch'
const Index = {
  name: 'delivery-record1',
  components: {
    PageHeader,
    Adsearch
  },
  mounted() {
    console.log()
  },
  mixins: [tableMixin],
  data() {
    return {
      isShow: false,
      visible1: false,
      visible: false,
      SelectType: 1,
      adSearchForm: [],
      selectsArr: [],
      // 通过物料
      adSearchForOthers1: [
        { name: '交货单号', value: 'DeliveryID' },
        { name: '销售单号', value: 'OrderID' },
        { name: '物料编号', value: 'InvCode' },
        { name: '品牌名称', value: 'BrandName' },
        { name: '物料名称', value: 'InvName' },
        { name: '物料类型', value: 'MaterialTypeName' },
        { name: '物料昵称', value: 'NickName' },
        { name: '供应商', value: 'SellCompanyName' },
        { name: 'Di码', value: 'DINum' },
        { name: '注册证号', value: 'RegisterNo' },
        { name: '批号', value: 'LotNum' },
        { name: '出库单号', value: 'StockOutID' },
        { name: '售达方', value: 'BuyCompanyName' },
        { name: '送达方', value: 'SendCompanyName' },
        { name: '出库时间', value: 'outdate', date: true }
      ],
      // 通过出库单
      adSearchForOthers: [
        { name: '交货单号', value: 'DeliveryID' },
        { name: '销售单号', value: 'OrderID' },
        { name: '出库单号', value: 'StockOutID' },
        { name: '售达方', value: 'BuyCompanyName' },
        { name: '送达方', value: 'SendCompanyName' },
        { name: '出库类型', value: 'StockOutType' },
        { name: '出库时间', value: 'outdate', date: true }
      ],
      formSearch: {
        SelectType: 1,
        KeyWords: '',
        PageIndex: 0,
        PageSize: 15,
        StockOutId: '', // 出库单号
        DeliveryID: '', // 出库单号
        StockOutDateStart: '', // 出库起始时间
        StockOutDateEnd: '', // 出库结束时间
        OrderID: '', // 采购单号
        StockOutID: '', // 出库单号 -
        StockOutType: '-1', // 出库类型 -
        InvCode: '', // 物料编号
        BrandName: '', // 品牌名称
        InvName: '', // 物料名称
        MaterialTypeName: '', // 物料类型
        NickName: '', // 物料昵称
        SellCompanyName: '', // 供应商
        RegisterNo: '', // z注册证号
        DINum: '', // DI码
        LotNum: '', // 批号
        Writer: '', // 操作人ID
        BuyCompanyName: '', // 售达方
        SendCompanyName: '', // 送达方
        outdate: []
      },
      selects: [],
      formIdx: ''
    }
  },
  watch: {
    selects(a) {
      if (a.length === 0) return this.formIdx = ''
      a.map(item => {
        this.formIdx += `${item.IDX}` + ','
        this.selectsArr.push(item.IDX)
      })
    }
  },
  beforeUpdate() {
    this.$nextTick(() => { // 在数据加载完，重新渲染表格
      this.$refs.testTable.doLayout()
    })
  },
  methods: {
    // 按订单查询 物料
    toSearchOrder(StockOutId) {
      if (this.SelectType === 2) {
        this.SelectType = 1
        this.formSearch.StockOutID = StockOutId
        this.getTableDataAsync()
      }
    },
    selectAll(e) {
      this.selects = e
    },
    select(row) {
      this.selects = row
    },
    async getTableDataAsync(page, pageSize) {
      this.formSearch.PageIndex = page || 1
      this.formSearch.PageSize = this.tablePageSize
      const response = await this.$api.StockOutLogByMaterial(this.formSearch)
      if (response.RetCode !== '0') return this.$message.error('错误：' + response.Message)
      this.tableData = response.Message
      this.tableTotalSize = response.Total
      this.formSearch.StockOutID = ''
      console.log(response)
      return response
    },
    async getTableDataAsync1() {
      this.formSearch.PageIndex = 1
      this.formSearch.PageSize = this.tablePageSize
      const response = await this.$api.StockOutLogByStockOutOrder(this.formSearch)
      if (response.RetCode !== '0') return this.$message.error('错误：' + response.Message)
      this.tableData = response.Message
      this.tableTotalSize = response.Total
      console.log(response)
      return response
    },
    Adsearch() {
      this.isShow = true
      this.adSearchForm = []
      if (this.SelectType === 1) {
        this.adSearchForm = this.adSearchForOthers1
      }
      if (this.SelectType === 2) {
        this.adSearchForm = this.adSearchForOthers
      }
    },
    searchAd() {
      if (this.formSearch.outdate.length === 2) {
        this.formSearch.StockOutDateStart = this.formSearch.outdate[0]
        this.formSearch.StockOutDateEnd = this.formSearch.outdate[1]
      }
      if (this.SelectType === 1) {
        this.getTableDataAsync()
      }
      if (this.SelectType === 2) {
        this.getTableDataAsync1()
      }
      this.isShow = false
    },
    selectType(type) {
      this.tableData = []
      this.visible = false
      this.selects = []
      this.currentPage = 1
      this.SelectType = type
      if (type === 1) {
        this.getTableDataAsync() // 物料
      }
      if (type === 2) {
        this.getTableDataAsync1()// 订单
      }
    },
    // 导出
    exportFile() {
      if (this.SelectType !== 1) return this.$message.info('只有物料可以导出')
      this.visible1 = !this.visible1
    },
    // 全部导出
    allExport() {
      console.log('asdadsdasdasdads')
      this.formSearch.FieldStr = JSON.stringify(this.tableListJson[ this.$refs.FieldManagement.name ])
      this.formSearch.SelectIDList = []
      this.visible1 = false
      this.$refs.ExportLoading.open()
      this.$api.ExportStockOutLogByMaterialByUserField(this.formSearch).then(res => {
        console.log(res)
        if (res.RetCode === '0') {
          const name = this.$minCommon.getExportName('出库记录')
          this.$refs.ExportLoading.success(res.Message, name)
          return this.$minCommon.downloadFile(res.Message, name)
        }
        return this.$message.error('请求失败：' + res.Message)
      })
    },
    // 批量导出
    piLiangExport() {
      this.visible1 = false
      if (this.selects.length <= 0) return this.$message.error('没有任何选中')
      this.formSearch.SelectIDList = this.selectsArr
      this.formSearch.FieldStr = JSON.stringify(this.tableListJson[ this.$refs.FieldManagement.name ])
      this.$refs.ExportLoading.open()
      this.$api.ExportStockOutLogByMaterialByUserField(this.formSearch).then(res => {
        if (res.RetCode === '0') {
          const name = this.$minCommon.getExportName('出库记录')
          this.$refs.ExportLoading.success(res.Message, name)
          return this.$minCommon.downloadFile(res.Message, name)
        }
        return this.$message.error('请求失败：' + res.Message)
      })
    }
  }
}
export default Index
